<template>
  <el-dialog
    :title="$t('editMenuCatalog.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="closeDialog"
  >
    <el-form
      ref="form"
      :model="editMenuCatalogInfo"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('editMenuCatalog.name')"
        prop="name"
      >
        <el-input
          v-model="editMenuCatalogInfo.name"
          :placeholder="$t('editMenuCatalog.requiredName')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('editMenuCatalog.icon')"
        prop="icon"
      >
        <el-input
          v-model="editMenuCatalogInfo.icon"
          :placeholder="$t('editMenuCatalog.requiredIcon')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('editMenuCatalog.sequence')"
        prop="seq"
      >
        <el-input
          v-model="editMenuCatalogInfo.seq"
          :placeholder="$t('editMenuCatalog.requiredSequence')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('editMenuCatalog.storeType')"
        prop="storeType"
      >
        <el-select
          v-model="editMenuCatalogInfo.storeType"
          :placeholder="$t('editMenuCatalog.requiredStoreType')"
          style="width:100%"
        >
          <el-option
            :label="$t('editMenuCatalog.operationTeam')"
            value="800900000001"
          />
          <el-option
            :label="$t('editMenuCatalog.merchant')"
            value="800900000005"
          />
          <el-option
            :label="$t('editMenuCatalog.developmentTeam')"
            value="800900000000"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('editMenuCatalog.page')"
        prop="url"
      >
        <el-input
          v-model="editMenuCatalogInfo.url"
          :placeholder="$t('editMenuCatalog.requiredPage')"
        />
      </el-form-item>
      <el-form-item
        :label="$t('editMenuCatalog.isShow')"
        prop="isShow"
      >
        <el-select
          v-model="editMenuCatalogInfo.isShow"
          :placeholder="$t('editMenuCatalog.requiredIsShow')"
          style="width:100%"
        >
          <el-option
            :label="$t('editMenuCatalog.yes')"
            value="Y"
          />
          <el-option
            :label="$t('editMenuCatalog.no')"
            value="N"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="editMenuCatalog"
      >
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateMenuCatalog } from '@/api/dev/menuCatalogApi'

export default {
  name: 'EditMenuCatalog',
  data() {
    return {
      dialogVisible: false,
      editMenuCatalogInfo: {
        caId: '',
        name: '',
        icon: '',
        seq: '',
        storeType: '',
        url: '',
        isShow: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('editMenuCatalog.nameRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('editMenuCatalog.nameMaxLength'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: this.$t('editMenuCatalog.iconRequired'), trigger: 'blur' },
          { max: 20, message: this.$t('editMenuCatalog.iconMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('editMenuCatalog.seqRequired'), trigger: 'blur' },
          { max: 11, message: this.$t('editMenuCatalog.seqMaxLength'), trigger: 'blur' }
        ],
        storeType: [
          { required: true, message: this.$t('editMenuCatalog.storeTypeRequired'), trigger: 'change' }
        ],
        url: [
          { required: true, message: this.$t('editMenuCatalog.urlRequired'), trigger: 'blur' },
          { max: 256, message: this.$t('editMenuCatalog.urlMaxLength'), trigger: 'blur' }
        ],
        isShow: [
          { required: true, message: this.$t('editMenuCatalog.isShowRequired'), trigger: 'change' }
        ],
        caId: [
          { required: true, message: this.$t('editMenuCatalog.idRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editMenuCatalogInfo = { ...row }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.editMenuCatalogInfo = {
        caId: '',
        name: '',
        icon: '',
        seq: '',
        storeType: '',
        url: '',
        isShow: ''
      }
    },
    async editMenuCatalog() {
      try {
        await this.$refs.form.validate()
        const res = await updateMenuCatalog(this.editMenuCatalogInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('editMenuCatalog.editSuccess'))
          this.closeDialog()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>